import { createApiRef } from '@backstage/core-plugin-api';
import type {
  DecomposeRequest,
  DecomposeResponse,
  ClarifyRequest,
  WorkflowStatus,
  FactoryGenerateRequest,
  FactoryGenerateResponse,
  FactoryPipelineStatus,
  FactoryBuildResponse,
  FactoryDeployResponse,
  FactoryValidateResponse,
  ExecutionRecord,
} from './types';

export interface WorkflowComposerApi {
  /* Decomposer */
  decompose(request: DecomposeRequest): Promise<DecomposeResponse>;
  clarify(workflowId: string, request: ClarifyRequest): Promise<DecomposeResponse>;
  getWorkflowStatus(workflowId: string): Promise<WorkflowStatus>;

  /* Agent Factory */
  generateAgent(request: FactoryGenerateRequest): Promise<FactoryGenerateResponse>;
  buildAgent(agentName: string): Promise<FactoryBuildResponse>;
  deployAgent(agentName: string): Promise<FactoryDeployResponse>;
  validateAgent(agentName: string): Promise<FactoryValidateResponse>;
  getFactoryStatus(agentName: string): Promise<FactoryPipelineStatus>;

  /* Execution History */
  listExecutions(): Promise<ExecutionRecord[]>;
  saveExecution(record: Omit<ExecutionRecord, 'createdAt' | 'updatedAt'>): Promise<void>;
  deleteExecution(id: string): Promise<void>;
}

export const workflowComposerApiRef = createApiRef<WorkflowComposerApi>({
  id: 'plugin.workflow-composer.service',
});
